import React, { useState, useEffect } from "react";

import CommonSlider from "../Common/CommonSidebar/CommonSidebar";
import CommonHeader from "../Common/CommonHeader/CommonHeader";
import Routes from "../Routes";

const AdminLayout = ({
  themeMode,
  themeColor,
  borderStroke,
  boxLayout,
  monochrome,
  borderRadius,
  iconColor,
  gradientColor,
}) => {
  const [sidebarMini, setSidebarMini] = useState(false);
  const [sidebarHidden, setSidebarHidden] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // {/* x---------------------------------x handle Resize Function For SideBar Hide And Show x---------------------------------x */ }
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
    if (window.innerWidth < 992) {
      setSidebarHidden(true);
    } else {
      setSidebarHidden(false);
    }
  };

  // {/* x---------------------------------x toggle Sidebar Hide And Mini x---------------------------------x */ }
  const toggleSidebar = () => {
    if (windowWidth > 991) {
      setSidebarMini((prevState) => !prevState);
    } else {
      setSidebarHidden((prevState) => !prevState);
    }
  };

  // {/* x---------------------------------x For Activate Resize Function x---------------------------------x */ }
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  return (
    // x---------------------------------x Dynamic Body SideBar and Header Code  x---------------------------------x
    <div data-theme={`theme-${themeColor}`} data-bs-theme={themeMode} className={`main_body ${gradientColor} ${borderStroke} ${boxLayout} ${monochrome} ${borderRadius}  ${sidebarMini ? "sidebar-mini" : ""} ${sidebarHidden ? "sidebar-hide" : ""} transition-all duration-500`} >
      <main className={`${boxLayout === "box-layout" ? "container mx-auto" : "w-full"} p-0 ${sidebarMini ? "rightbar-mini" : ""} ${sidebarHidden ? "rightbar-hide" : ""}`}>
        {/* x---------------------------------x Main Common SideBar Section x---------------------------------x */}
        <CommonSlider iconColor={iconColor} toggleSidebarMobile={toggleSidebar} />

        <div className="content">
          {/* x---------------------------------x Main Common Header Section x---------------------------------x */}
          <CommonHeader toggleShow={true} menuShow={true} toggleSidebar={toggleSidebar} toggleSidebarMobile={toggleSidebar} />
          <div className="px-[15px] py-3">
            {/* // x---------------------------------x All Pages Routes x---------------------------------x */}
            <Routes />
          </div>
        </div>
      </main>
    </div>

  );
};

export default AdminLayout;
